import LanguagePack from "../../../../../shared/lib/html5-software-library/src/ranj/language/LanguagePack";
import GameConfig from "../core/model/GameConfig";
import Scenario from "../ngt/scenario/Scenario";
import ScenarioLibrary from "../ngt/scenario/ScenarioLibrary";
import BaseInfoPanelMediator from "./BaseInfoPanelMediator";

export default class CastInfoPanelMediator extends BaseInfoPanelMediator {
    /**
     * 
     * @param {createjs.MovieClip} target 
     * @param {LanguagePack} languagePack 
     * @param {GameConfig} gameConfig 
     * @param {ScenarioLibrary} scenarioLibrary
     */
    constructor(target, dispatcher, languagePack, layoutManager, soundManager, gameConfig, scenarioLibrary) {
        super(target, dispatcher, languagePack, layoutManager, soundManager);

        this._scenarioLibrary = scenarioLibrary;
        this._gameConfig = gameConfig;
    }

    initialize() {
        super.initialize();
        const scenario = this._scenarioLibrary.getCurrentScenario();
        this._initializeCast(scenario);
        this._panel.titleTextfield.text = this.getText("cast.title");
        this._panel.closeInstructionsTextfield.text = this.getText("cast.closeInstructions");
        this._panel.episodeTitleTextfield.text = this.getText(scenario.name);
    }

    /**
     * 
     * @param {Scenario} scenario 
     */
    _initializeCast(scenario) {
        const castConfig = this._gameConfig.getCast();

        // NB: disable all cast elements, set description, and get top-most Y value
        let topmostY;
        for (const characterConfig of Object.values(castConfig)) {
            const characterElement = this._panel[characterConfig.castMovieClip];
            if (!characterElement) {
                continue;
            }
            if (!topmostY || topmostY > characterElement.y) {
                topmostY = characterElement.y;
            }
            this._setCenteredText(characterElement.bioTextfield, this._languagePack.getText(characterConfig.description));
            characterElement.visible = false;
        }

        // enable cast element according to characters for scenario and position them
        let positionY = topmostY;
        for (const characterId of scenario.castIds) {
            const characterConfig = castConfig[characterId];
            if (!characterConfig) {
                console.error(`[InfoPanelMediator] Could not initialize cast character, cannot find config with id ${characterId}`);
                continue;
            }
            const characterElement = this._panel[characterConfig.castMovieClip];
            characterElement.y = positionY;
            characterElement.visible = true;
            positionY += characterElement.getBounds().height + 46;
        }
    }
}